module.exports = __webpack_public_path__ + "static/media/ap.64eb9bd8.svg";